export const useAudio = (audio_src: string) => {
	const audio = new Audio(audio_src);
	return audio;
};
